import { render, staticRenderFns } from "./info-screen.vue?vue&type=template&id=1c3a0c1f&scoped=true&"
import script from "./info-screen.vue?vue&type=script&lang=js&"
export * from "./info-screen.vue?vue&type=script&lang=js&"
import style0 from "./info-screen.vue?vue&type=style&index=0&id=1c3a0c1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a0c1f",
  null
  
)

export default component.exports